// API discovery (ADR-021, ui-spec §4.7): which kinds the org is served and at which stage. Alpha and Beta badges
// and "only when served" navigation come from here, never from hard-coded lists.
import type { NodusClient } from "./client";

export interface ServedKind {
  kind: string;
  resource: string;
  version: string;
  stage: "GA" | "Beta" | "Alpha";
}

interface APIResourceList {
  groupVersion: string;
  resources: { name: string; kind: string }[];
}

export function stageOf(version: string): ServedKind["stage"] {
  if (/alpha/.test(version)) return "Alpha";
  if (/beta/.test(version)) return "Beta";
  return "GA";
}

/** Reads `/apis/nodus.dev` then each served version's resource list; subresources (`jobs/log`) are skipped. */
export async function discoverKinds(client: NodusClient, org: string): Promise<ServedKind[]> {
  const group = await client.get<{ versions: { version: string }[] }>("/apis/nodus.dev", { org });
  const lists = await Promise.all(
    group.versions.map((v) => client.get<APIResourceList>(`/apis/nodus.dev/${v.version}`, { org }).then((l) => ({ v: v.version, l }))),
  );
  return lists.flatMap(({ v, l }) =>
    l.resources.filter((r) => !r.name.includes("/")).map((r) => ({ kind: r.kind, resource: r.name, version: v, stage: stageOf(v) })),
  );
}
